import React from 'react';
import {getMediaUrl} from '@wix/wixstores-client-core/dist/es/src/media/mediaService';
import {SocialIcon} from './SocialIcon/SocialIcon';
import {SocialVendor} from '../../constants';
import {withGlobalProps, ProvidedGlobalProps} from '../../providers/globalPropsProvider';
import {
  WhatsappSocialNetwork,
  FacebookSocialNetwork,
  SocialShareService,
  TwitterSocialNetwork,
  PinterestSocialNetwork,
} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/ProductSocialShare/SocialShareService';
import style from './ProductSocial.scss';
import {getDefaultProductMedia, shouldRenderVendorFromStyledParams} from './ProductSocialUtils';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';

export interface ProductSocialProps extends ProvidedGlobalProps, IProvidedTranslationProps {
  isLiveSiteMode?: boolean;
}

const socialNetworks = {
  [SocialVendor.WhatsApp]: WhatsappSocialNetwork,
  [SocialVendor.Facebook]: FacebookSocialNetwork,
  [SocialVendor.Twitter]: TwitterSocialNetwork,
  [SocialVendor.Pinterest]: PinterestSocialNetwork,
};
class ProductSocialComponent extends React.Component<ProductSocialProps> {
  public static defaultProps = {
    isLiveSiteMode: true,
  };

  private readonly openSocialShareWindow = (shareType: SocialVendor) => {
    const {product, productUrl} = this.props.globals;

    const vendor = new socialNetworks[shareType]();
    const productImage = getDefaultProductMedia(product);
    const options = {asJpg: false, isSEOBot: true};
    const imageUrl = getMediaUrl(productImage, productImage, options);
    const socialShareUrl = new SocialShareService(vendor).getSocialNetworkUrl({
      title: product.name,
      url: productUrl,
      imageUrl,
    });

    window.open(socialShareUrl, '_blank', 'width=700, height=600, top=300, left=300, chrome=yes, centerscreen');
  };

  public onClick = (socialVendor: SocialVendor) => {
    const {
      globals: {
        socialSharing: {onClick: controllerCallback},
      },
    } = this.props;

    controllerCallback({socialButton: socialVendor});
    return this.openSocialShareWindow(socialVendor);
  };

  private readonly renderVendorIcon = (vendor: SocialVendor) => {
    const {t} = this.props;

    return (
      <SocialIcon
        key={`social-sharing-${vendor}`}
        type={vendor}
        label={t(`SHARE_TITLE_${vendor.toUpperCase()}`)}
        onClick={() => this.onClick(vendor)}
        className={style.icon}
      />
    );
  };

  public render(): JSX.Element {
    return (
      <div data-hook="social-sharing" className={style.rootComp}>
        {Object.keys(socialNetworks)
          .filter((vendor: SocialVendor) => shouldRenderVendorFromStyledParams(vendor, this.props))
          .map(this.renderVendorIcon)}
      </div>
    );
  }
}

export const ProductSocialOld: React.FC<ProductSocialProps> = withGlobalProps(
  withTranslations('globals.texts')(ProductSocialComponent)
);
